import { BrowserModule, HammerGestureConfig, HAMMER_GESTURE_CONFIG } from '@angular/platform-browser';
import { DataTablesModule } from "angular-datatables";
import { NgModule, LOCALE_ID } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { DropzoneModule, DropzoneConfigInterface, DROPZONE_CONFIG } from 'ngx-dropzone-wrapper';
import { DatepickerModule } from 'ng2-datepicker';
import { NotifierModule, NotifierOptions } from 'angular-notifier';
import { QuillModule } from 'ngx-quill';
import { UiSwitchModule } from 'ngx-ui-switch';
import { NgCircleProgressModule } from 'ng-circle-progress';
import { JwtModule } from '@auth0/angular-jwt';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxPaginationModule } from 'ngx-pagination';
import {NgxGalleryModule} from '@kolkov/ngx-gallery';
import { DndModule } from "ngx-drag-drop";
import { NgxSpinnerModule } from 'ngx-spinner';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { CarouselModule } from 'ngx-owl-carousel-o';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { SocialLoginModule, SocialAuthServiceConfig } from 'angularx-social-login';
import { GoogleLoginProvider } from 'angularx-social-login';
import { SafeUrlPipe } from './pipes/safe-url.pipe';
import { MatDialogModule } from '@angular/material/dialog';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';

import { ScopeModule } from './main/processes/scope/scope.module';
import { AppLoadModule } from './app-load.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './/app-routing.module';
import { LoginComponent } from './login/login.component';
import { MainComponent } from './main/main.component';
import { NavbarComponent } from './main/navbar/navbar.component';
import { ProcessesComponent } from './main/processes/processes.component';
import { ProcessHeaderComponent } from './main/processes/new/process-header/process-header.component';
import { ProcessListComponent } from './main/processes/process-list/process-list.component';
import { ProcessGridComponent } from './main/processes/process-grid/process-grid.component';
import { ProcessSummaryComponent } from './main/processes/process-list/process-summary/process-summary.component';
import { PolicyService } from './service/policy.service';
import { TypePolicyService } from './service/typePolicy.service';
import { ProcessService } from './service/process.service';
import { AuthenticationService } from './service/auth.service';
import { AuthGuardService } from './service/auth-guard.service';
import { NewComponent } from './main/processes/new/new.component';
import { GlobalSettings } from './model/settings.model';
import { DashboardComponent } from './main/dashboard/dashboard.component';
import { TypeProcessComponent } from './main/processes/type-process/type-process.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { UserService } from './service/user.service';
import { InstanceService } from './service/instance.service';
import { DashSummaryComponent } from './main/dashboard/dash-summary/dash-summary.component';
import { AnalyticsService } from './service/analytics.service';
import { ExportService } from './service/export.services';
import { UsersComponent } from './main/users/users.component';
import { LoginHistoryComponent } from './main/login-history/login-history.component';
import { UsersPolicyService } from './service/users-policy.service';
import { SecurityService } from './service/security.service';
import { FilterPipe } from './main/filter.pipe';
import { AuthGuardAdminService } from './service/auth-guard-admin.service';
import {NgxMaskModule, IConfig} from 'ngx-mask';
import { InstanceQueryService } from './service/instance-query.service';
import { ProcessFilterComponent } from './main/processes/process-list/process-filter/process-filter.component';
import { FilterTextComponent } from './main/processes/process/dynamicProcess/filter-text/filter-text.component';
import { GridComponent } from './main/processes/process/dynamicProcess/grid/grid.component';
import { DatatableComponent } from './main/processes/process/dynamicProcess/datatable/datatable.component';
import { FilterCollectionComponent } from './main/processes/process/dynamicProcess/filter-collection/filter-collection.component';
import { FilterNumericComponent } from './main/processes/process/dynamicProcess/filter-numeric/filter-numeric.component';
import { FilterCurrencyComponent } from './main/processes/process/dynamicProcess/filter-currency/filter-currency.component';
import { BindingsComponent } from './main/processes/process/dynamicProcess/bindings/bindings.component';
import { FilterPathComponent } from './main/processes/process/dynamicProcess/filter-path/filter-path.component';
import { DynamicModule } from './main/dynamic/dynamic.module';
import { DynamicItemConfig } from './main/dynamic/model/dynamic-item-config';
import { WorkflowGatewayService } from './service/workflow-gateway.service';
import { InputTextDefaultComponent } from './main/processes/process/dynamicProcess/input-text-default/input-text-default.component';
import { InputTextGoogleMapsComponent } from './main/processes/process/dynamicProcess/input-text-google-maps/input-text-google-maps.component';
import { LabelSequentialCodeComponent } from './main/processes/process/dynamicProcess/label-sequential-code/label-sequential-code.component';
import { LabelTitleSubtitleComponent } from './main/processes/process/dynamicProcess/label-title-subtitle/label-title-subtitle.component';
import { InputComponent } from './main/processes/process/dynamicProcess/input/input.component';
import { InputRadioDefaultComponent } from './main/processes/process/dynamicProcess/input-radio-default/input-radio-default.component';
import { SelectComponent } from './main/processes/process/dynamicProcess/select/select.component';
import { SelectMultipleComponent } from './main/processes/process/dynamicProcess/select-multiple/select-multiple.component';
import { CalcComponent } from './main/processes/process/dynamicProcess/calc/calc.component';
import { SectionComponent } from './main/processes/process/dynamicProcess/section/section.component';
import { RichTextComponent } from './main/processes/process/dynamicProcess/rich-text/rich-text.component';
import { UploadComponent } from './main/processes/process/dynamicProcess/upload/upload.component';
import { InputDatepickerComponent } from './main/processes/process/dynamicProcess/input-datepicker/input-datepicker.component';
import { TextareaComponent } from './main/processes/process/dynamicProcess/textarea/textarea.component';
import { SwitchComponent } from './main/processes/process/dynamicProcess/switch/switch.component';
import { AccordionComponent } from './main/processes/process/dynamicProcess/accordion/accordion.component';
import { InputCurrencyComponent } from './main/processes/process/dynamicProcess/input-currency/input-currency.component';
import { InputDecimalComponent } from './main/processes/process/dynamicProcess/input-decimal/input-decimal.component';
import { RepeaterComponent } from './main/processes/process/dynamicProcess/repeater/repeater.component';
import { SwitchTextComponent } from './main/processes/process/dynamicProcess/switch-text/switch-text.component';
import { SwitchContainerComponent } from './main/processes/process/dynamicProcess/switch-container/switch-container.component';
import { SwithRangeDateResultComponent } from './main/processes/process/dynamicProcess/swith-range-date-result/swith-range-date-result.component';
import { SwitchSelectMultipleComponent } from './main/processes/process/dynamicProcess/switch-select-multiple/switch-select-multiple.component';
import { SwithCurrencyComponent } from './main/processes/process/dynamicProcess/swith-currency/swith-currency.component';
import { SwitchNumberComponent } from './main/processes/process/dynamicProcess/switch-number/switch-number.component';
import { UserComponent } from './main/processes/process/dynamicProcess/user/user.component';
import { GroupComponent } from './main/processes/process/dynamicProcess/group/group.component';
import { UserSelectComponent } from './main/processes/process/dynamicProcess/user-select/user-select.component';
import { UnidadeSelectComponent } from './main/processes/process/dynamicProcess/unidade-select/unidade-select.component';
import { BooleanTextComponent } from './main/processes/process/dynamicProcess/boolean-text/boolean-text.component';
import { BooleanLabelComponent } from './main/processes/process/dynamicProcess/boolean-label/boolean-label.component';
import { CurrencyTextComponent } from './main/processes/process/dynamicProcess/currency-text/currency-text.component';
import { BooleanComponent } from './main/processes/process/dynamicProcess/boolean/boolean.component';
import { LabelComponent } from './main/processes/process/dynamicProcess/label/label.component';
import { DynamicTaskComponent } from './main/processes/process/dynamicProcess/dynamic-task/dynamic-task.component';
import { ImageComponent } from './main/processes/process/dynamicProcess/image/image.component';
import { FileComponent } from './main/processes/process/dynamicProcess/file/file.component';
import { FilesSortPipe } from './main/processes/process/dynamicProcess/upload/files-sort.pipe';
import { LabelTitleSubtitleAltComponent } from './main/processes/process/dynamicProcess/label-title-subtitle-alt/label-title-subtitle-alt.component';
import { InputTextCheckboxComponent } from './main/processes/process/dynamicProcess/input-text-checkbox/input-text-checkbox.component';
import { ProcessComponent } from './main/processes/process/process.component';
import { InputTextLinkComponent } from './main/processes/process/dynamicProcess/input-text-link/input-text-link.component';
import { CreatePasswordComponent } from './create-password/create-password.component';
import { ActionButtonComponent } from './main/processes/process/dynamicProcess/action-button/action-button.component';
import { ProcessSelectComponent } from './main/processes/process/dynamicProcess/process-select/process-select.component';
import { ProcessListDynamicComponent } from './main/processes/process/dynamicProcess/process-list/process-list.component';
import { ButtonComponent } from './components/button/button.component';
import { LoadingComponent } from './components/loading/loading.component';
import { BackdropComponent } from './components/backdrop/backdrop.component';
import { InstallAppButton } from './components/install-app-button/install-app-button.component';
import { AddressComponent } from './main/processes/process/dynamicProcess/address/address.component';
import { DefaultComponent } from './main/processes/process/dynamicProcess/default/defult.component';
import { FooterComponent } from './main/footer/footer.component';
import { TopbarComponent } from './main/topbar/topbar.component';
import { RecoverPasswordComponent } from './recover-password/recover-password.component';
import { SelectContainerComponent } from './main/processes/process/dynamicProcess/select-container/select-container.component';
import { DatePipe, HashLocationStrategy, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { DesignService } from './service/design.service';
import { LabelDevComponent } from './components/label-dev/label-dev.component';
import { NavigationService } from './service/navigation.service';
import { TemplateComponent } from './print/template/template.component';
import { BackdropService } from './service/backdrop.service';
import { FilterDatepickerComponent } from './main/processes/process/dynamicProcess/filter-datepicker/filter-datepicker.component';
import { RadioComponent } from './main/processes/process/dynamicProcess/radio/radio.component';
import { RadioContainerComponent } from './main/processes/process/dynamicProcess/radio-container/radio-container.component';
import { CompanyComponent } from './main/processes/process/dynamicProcess/company/company.component';
import { QrcodeComponent } from './main/processes/process/dynamicProcess/qrcode/qrcode.component';
import { QRCodeModule } from 'angularx-qrcode';
import { NotificationSharedService } from './service/notification-shared.service';
import { FaceRecognitionComponent } from './main/processes/process/dynamicProcess/face-recognition/face-recognition.component';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { ChatComponent } from './main/processes/process/dynamicProcess/chat/chat.component';
import { CurrencyService } from './service/currency.service';
import { LinkComponent } from './main/processes/process/dynamicProcess/link/link.component';
import { TokenComponent } from './main/processes/process/dynamicProcess/token/token.component';
import { SocialLoginComponent } from './main/processes/process/dynamicProcess/social-login/social-login.component';
import { MetabaseFrameComponent } from './main/dashboard/metabase-frame/metabase-frame.component';
import { AuthCallbackComponent } from './auth/auth-callback.component';
import { MsalAuthService } from './service/msal-auth.service';
import { CalendarComponent } from './main/processes/process/dynamicProcess/calendar/calendar.component';
import { DashboardFilterComponent } from './main/dashboard/dashboard-filter/dashboard-filter.component';
import { QITechDeviceScanComponent  } from './main/processes/process/dynamicProcess/qitech-device-scan/qitech-device-scan.component';
import { ProcessRepeaterComponent } from './main/processes/process/dynamicProcess/process-repeater/process-repeater.component';
import { DialogBoxComponent } from './main/processes/process/dynamicProcess/dialog-box/dialog-box.component';
import { ProrrogacaoComponent } from './components/stik/prorrogacao/prorrogacao.component';
import { AbatimentoComponent } from './components/stik/abatimento/abatimento.component';
import { BaixaComponent } from './components/stik/baixa/baixa.component';
import { HistoryComponent } from './components/stik/history/history.component';
import { ImageViewComponent } from './main/processes/process/dynamicProcess/image-view/image-view.component';
import { MapViewComponent } from './main/processes/process/dynamicProcess/map-view/map-view.component';
import { RedirectComponent } from './main/processes/process/dynamicProcess/redirect/redirect.component';

export function customTokenGetter() {
  return localStorage.getItem('access_token');
}

var dynamicItemConfigProcess: DynamicItemConfig = {
  mapping: [
    { name: 'text', component: InputTextDefaultComponent },
    { name: 'textGoogleMaps', component: InputTextGoogleMapsComponent },
    { name: 'textLink', component: InputTextLinkComponent },
    { name: 'labelSequentialCode', component: LabelSequentialCodeComponent },
    { name: 'labelTitleSubtitle', component: LabelTitleSubtitleComponent },
    { name: 'link', component: LinkComponent },
    { name: 'number', component: InputTextDefaultComponent },
    { name: 'booleanConditional', component: InputComponent },
    { name: 'booleanoExclusivo', component: InputRadioDefaultComponent },
    { name: 'collection', component: SelectComponent },
    { name: 'collectionMultiple', component: SelectMultipleComponent },
    { name: 'calc', component: CalcComponent },
    { name: 'section', component: SectionComponent },
    { name: 'richText', component: RichTextComponent },
    { name: 'upload', component: UploadComponent },
    { name: 'file', component: UploadComponent },
    { name: 'datepicker', component: InputDatepickerComponent },
    { name: 'dateTime', component: InputDatepickerComponent },
    { name: 'textarea', component: TextareaComponent },
    { name: 'boolean', component: SwitchComponent },
    { name: 'accordion', component: AccordionComponent },
    { name: 'currency', component: InputCurrencyComponent },
    { name: 'decimal', component: InputDecimalComponent },
    { name: 'repeater', component: RepeaterComponent},
    { name: 'switchText', component: SwitchTextComponent },
    { name: 'switchContainer', component: SwitchContainerComponent },
    { name: 'switchRangeDateResult', component: SwithRangeDateResultComponent },
    { name: 'swithSelectMultiple', component: SwitchSelectMultipleComponent },
    { name: 'swithCurrency', component: SwithCurrencyComponent },
    { name: 'switchNumber', component: SwitchNumberComponent },
    { name: 'user', component: UserComponent },
    { name: 'group', component: GroupComponent },
    { name: 'userSelect', component: UserSelectComponent },
    { name: 'unidadeSelect', component: UnidadeSelectComponent},
    { name: 'booleanText', component: BooleanTextComponent },
    { name: 'booleanLabel', component: BooleanLabelComponent },
    { name: 'currencyText', component: CurrencyTextComponent },
    { name: 'exclusiveBoolean', component: BooleanComponent },
    { name: 'label', component: LabelComponent },
    { name: 'task', component: DynamicTaskComponent },
    { name: 'filterText', component: FilterTextComponent },
    { name: 'grid', component: GridComponent },
    { name: 'datatable', component: DatatableComponent },
    { name: 'filterCollection', component: FilterCollectionComponent },
    { name: 'filterNumeric', component: FilterNumericComponent },
    { name: 'filterCurrency', component: FilterCurrencyComponent },
    { name: 'filterDatepicker', component: FilterDatepickerComponent },
    { name: 'binding', component: BindingsComponent },
    { name: 'filterPath', component: FilterPathComponent },
    { name: 'actionButton', component: ActionButtonComponent },
    { name: 'actionToggle', component: BooleanComponent },
    { name: 'processSelect', component: ProcessSelectComponent},
    { name: 'processList', component: ProcessListDynamicComponent },
    { name: 'password', component: UserComponent },
    { name: 'register-confirmation', component: UserComponent },
    { name: 'company', component: CompanyComponent },
    { name: 'address', component: AddressComponent },
    { name: 'option', component: DefaultComponent },
    { name: 'condition', component: DefaultComponent },
    { name: 'conditionalValue', component: DefaultComponent },
    { name: 'textView', component: LabelComponent },
    { name: 'switchCollection', component: DefaultComponent},
    { name: 'choicesContainer', component: SelectContainerComponent},
    { name: 'radio', component: RadioComponent },
    { name: 'radioContainer', component: RadioContainerComponent },
    { name: 'checkbox', component: InputTextCheckboxComponent },
    { name: 'hour', component: InputTextDefaultComponent },
    { name: 'minute', component: InputTextDefaultComponent },
    { name: 'second', component: InputTextDefaultComponent },
    { name: 'year', component: InputTextDefaultComponent },
    { name: 'month', component: InputTextDefaultComponent },
    { name: 'week', component: InputTextDefaultComponent },
    { name: 'day', component: InputTextDefaultComponent },
    { name: 'qrcode', component: QrcodeComponent },
    { name: 'QITechFaceRecognition', component: FaceRecognitionComponent },
    { name: 'chat', component: ChatComponent },
    { name: 'socialLogin', component: SocialLoginComponent },
    { name: 'tokenValidation', component: TokenComponent },
    { name: 'calendarSelect', component: CalendarComponent },
    { name: 'QITechDeviceScan', component: QITechDeviceScanComponent },
    { name: 'ProcessRepeater', component: ProcessRepeaterComponent },
    { name: 'DialogBox', component: DialogBoxComponent },
    { name: 'ImageView', component: ImageViewComponent },
    { name: 'MapView', component: MapViewComponent },
    { name: 'redirect', component: RedirectComponent }
  ]
}

/**
 * Custom angular notifier options
 */
const customNotifierOptions: NotifierOptions = {
  position: {
    horizontal: {
      position: 'right',
      distance: 12
    },
    vertical: {
      position: 'bottom',
      distance: 12,
      gap: 10
    }
  },
  theme: 'material',
  behaviour: {
    autoHide: 4000,
    onClick: 'hide',
    onMouseover: 'pauseAutoHide',
    showDismissButton: true,
    stacking: 1
  },
  animations: {
    enabled: true,
    show: {
      preset: 'slide',
      speed: 300,
      easing: 'ease'
    },
    hide: {
      preset: 'fade',
      speed: 300,
      easing: 'ease',
      offset: 50
    },
    shift: {
      speed: 300,
      easing: 'ease'
    },
    overlap: 150
  }
};

//dropzone
const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
  // POST:
  url: 'https://httpbin.org/post',
  maxFilesize: 50,
  acceptedFiles: 'image/*'
};

const googleLoginOptions = {
  scope: 'profile email',
  plugin_name:'login',
  oneTapEnabled: false,
  prompt: 'select_account'
}; 

@NgModule({
  declarations: [
    AppComponent,
    SafeHtmlPipe,
    SafeUrlPipe,
    LoginComponent,
    MainComponent,
    NavbarComponent,
    ProcessesComponent,
    ProcessHeaderComponent,
    ProcessListComponent,
    ProcessGridComponent,
    ProcessSummaryComponent,
    ProcessComponent,
    NewComponent,
    DashboardComponent,
    TypeProcessComponent,
    DashSummaryComponent,
    UsersComponent,
    LoginHistoryComponent,
    FilterPipe,
    ProcessFilterComponent,
    SectionComponent,
    SelectComponent,
    SelectMultipleComponent,
    InputComponent,
    RichTextComponent,
    UploadComponent,
    InputTextDefaultComponent,
    InputTextGoogleMapsComponent,
    InputTextCheckboxComponent,
    InputRadioDefaultComponent,
    InputDatepickerComponent,
    TextareaComponent,
    SwitchComponent,
    AccordionComponent,
    InputCurrencyComponent,
    InputDecimalComponent,
    RepeaterComponent,
    SwitchTextComponent,
    SwitchContainerComponent,
    SwithRangeDateResultComponent,
    SwitchSelectMultipleComponent,
    SwithCurrencyComponent,
    SwitchNumberComponent,
    UserComponent,
    GroupComponent,
    ImageComponent,
    FileComponent,
    FilesSortPipe,
    UserSelectComponent,
    UnidadeSelectComponent,
    CalcComponent,
    LabelSequentialCodeComponent,
    LabelTitleSubtitleComponent,
    LabelTitleSubtitleAltComponent,
    BooleanTextComponent,
    BooleanLabelComponent,
    CurrencyTextComponent,
    BooleanComponent,
    LabelComponent,
    DynamicTaskComponent,
    FilterTextComponent,
    GridComponent,
    DatatableComponent,
    FilterCollectionComponent,
    FilterNumericComponent,
    FilterCurrencyComponent,
    FilterDatepickerComponent,
    BindingsComponent,
    FilterPathComponent,
    InputTextLinkComponent,
    CreatePasswordComponent,
    ActionButtonComponent,
    ProcessSelectComponent,
    ProcessListDynamicComponent,
    ButtonComponent,
    LoadingComponent,
    BackdropComponent,
    InstallAppButton,
    CompanyComponent,
    AddressComponent,
    DefaultComponent,
    FooterComponent,
    TopbarComponent,
    RecoverPasswordComponent,
    SelectContainerComponent,
    LabelDevComponent,
    TemplateComponent,
    RadioContainerComponent,
    RadioComponent,
    QrcodeComponent,
    FaceRecognitionComponent,
    ChatComponent,
    LinkComponent,
    TokenComponent,
    SocialLoginComponent,
    MetabaseFrameComponent,
    AuthCallbackComponent,
    CalendarComponent,
    DashboardFilterComponent,
    QITechDeviceScanComponent,
    ProcessRepeaterComponent,
    DialogBoxComponent,
    ProrrogacaoComponent,
    AbatimentoComponent,
    BaixaComponent,
    HistoryComponent,
    ImageViewComponent,
    MapViewComponent,
    RedirectComponent
  ],
  entryComponents: [
    SectionComponent,
    SelectComponent,
    SelectMultipleComponent,
    InputComponent,
    RichTextComponent,
    UploadComponent,
    InputTextDefaultComponent,
    InputTextGoogleMapsComponent,
    InputTextLinkComponent,
    InputTextCheckboxComponent,
    InputRadioDefaultComponent,
    InputDatepickerComponent,
    TextareaComponent,
    SwitchComponent,
    AccordionComponent,
    InputCurrencyComponent,
    InputDecimalComponent,
    RepeaterComponent,
    SwitchTextComponent,
    SwitchContainerComponent,
    SwithRangeDateResultComponent,
    SwitchSelectMultipleComponent,
    SwithCurrencyComponent,
    SwitchNumberComponent,
    UserComponent,
    GroupComponent,
    ImageComponent,
    FileComponent,
    UserSelectComponent,
    UnidadeSelectComponent,
    CalcComponent,
    LabelSequentialCodeComponent,
    LabelTitleSubtitleComponent,
    LabelTitleSubtitleAltComponent,
    BooleanTextComponent,
    BooleanLabelComponent,
    CurrencyTextComponent,
    BooleanComponent,
    LabelComponent,
    DynamicTaskComponent,
    FilterTextComponent,
    GridComponent,
    DatatableComponent,
    FilterCollectionComponent,
    FilterNumericComponent,
    FilterCurrencyComponent,
    FilterDatepickerComponent,
    BindingsComponent,
    FilterPathComponent,
    InputTextLinkComponent,
    CreatePasswordComponent,
    ActionButtonComponent,
    ProcessSelectComponent,
    ProcessListDynamicComponent,
    AddressComponent,
    DefaultComponent,
    SelectContainerComponent,
    RadioContainerComponent,
    RadioComponent,
    QrcodeComponent,
    FaceRecognitionComponent,
    ChatComponent,
    LinkComponent,
    TokenComponent,
    SocialLoginComponent,
    CalendarComponent,
    QITechDeviceScanComponent,
    ProcessRepeaterComponent,
    DialogBoxComponent,
    ImageViewComponent,
    MapViewComponent,
    RedirectComponent
  ],
  imports: [
    NgSelectModule,
    AppLoadModule,
    BrowserModule,
    DataTablesModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    DropzoneModule,
    QuillModule,
    DatepickerModule,
    NotifierModule.withConfig(customNotifierOptions),
    ScopeModule,
    UiSwitchModule.forRoot({
      size: 'medium',
      color: '#7a94e5',
      switchColor: '#fff',
      defaultBgColor: '#f4f5f8',
      defaultBoColor : '#f4f5f8',
      checkedLabel: 'sim',
      uncheckedLabel: 'não'
    }),
    NgCircleProgressModule.forRoot({
      radius: 100,
      outerStrokeWidth: 14,
      innerStrokeWidth: 8,
      outerStrokeColor: "#78C000",
      innerStrokeColor: "#C7E596",
      animationDuration: 300,
      outerStrokeLinecap: 'round',
      toFixed: 0,
      renderOnClick: true
    }),
    JwtModule.forRoot({
      config: {
        tokenGetter: customTokenGetter
      }
    }),
    InfiniteScrollModule,
    NgxPaginationModule,
    NgxMaskModule.forRoot(),
    DynamicModule.forRoot(dynamicItemConfigProcess),
    NgxGalleryModule,
    DndModule,
    NgxSpinnerModule,
    ModalModule.forRoot(),
    BrowserAnimationsModule,
    BsDropdownModule.forRoot(),
    TooltipModule.forRoot(),
    PopoverModule.forRoot(),
    CarouselModule,
    DragDropModule,
    QRCodeModule,
    SocialLoginModule,
    MatDialogModule,
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.serviceWorker ?? environment.production })
  ],
  providers: [
    {
      provide: LocationStrategy,
      useClass: PathLocationStrategy
    },
    PolicyService,
    TypePolicyService,
    ProcessService,
    {
      provide: DROPZONE_CONFIG,
      useValue: DEFAULT_DROPZONE_CONFIG,
    },
    AuthGuardService,
    AuthGuardAdminService,
    AuthenticationService,
    CurrencyService,
    GlobalSettings,
    InstanceService,
    UserService,
    AnalyticsService,
    ExportService,
    SecurityService,
    UsersPolicyService,
    InstanceQueryService,
    WorkflowGatewayService,
    NavigationService,
    { provide: LOCALE_ID, useValue: 'pt-BR' },
    { provide: HAMMER_GESTURE_CONFIG, useClass: AppModule },
    DesignService,
    BackdropService,
    DatePipe,
    NotificationSharedService,
    MsalAuthService,
    {
      provide: 'SocialAuthServiceConfig',
      useValue: {
        autoLogin: false,
        providers: [
          {
            id: GoogleLoginProvider.PROVIDER_ID,
            provider: new GoogleLoginProvider(
              '961964046846-l5ardf8lslu59o6ug230v09gi7li0tk7.apps.googleusercontent.com',
              googleLoginOptions
            )
          }
        ]
      } as SocialAuthServiceConfig,
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule extends HammerGestureConfig {
  overrides = <any>{
    'pinch': { enable: false },
    'rotate': { enable: false }
  };
}
